import React from 'react';
import PropTypes from 'prop-types';
import {
  FloatingLabelInput as Input,
  FloatingLabelSelect as Select
} from '../../../../Elements';
import { DthcActions } from '../../../../Modules';
import { Card } from 'semantic-ui-react';
import styles from '../../Form.scss';

export default class SchemaFieldEditDesktop extends React.Component {
  static propTypes = {
    commitUpdate: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    deleteQuestion: PropTypes.func.isRequired,
    FieldComponent: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    getQuestionType: PropTypes.func.isRequired,
    onQuestionTypeChange: PropTypes.func.isRequired,
    objectKey: PropTypes.string.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object.isRequired,
    formData: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.onTitleChange = this.onTitleChange.bind(this);
    this.onDescriptionChange = this.onDescriptionChange.bind(this);
  }

  componentWillUnmount() {
    this.props.commitUpdate();
  }

  onTitleChange(e) {
    const { schema, uiSchema, formData } = this.props;
    this.props.onChange({
      schema: Object.assign({}, schema, { title: e.target.value }),
      uiSchema,
      formData
    });
  }

  onDescriptionChange(e) {
    const { schema, uiSchema, formData } = this.props;
    this.props.onChange({
      schema,
      uiSchema: Object.assign({}, uiSchema, { 'ui:description': e.target.value }),
      formData
    });
  }

  render() {
    const {
      FieldComponent,
      schema,
      uiSchema,
      onChange,
      deleteQuestion,
      objectKey,
      reset,
      ...props
    } = this.props;

    return (
      <Card fluid style={{ marginBottom: '2em' }}>
        <Card.Content>
          {schema.type !== 'null' &&
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <h3>
                  <Input
                    autoFocus
                    autoHeight
                    name='title'
                    value={schema.title || ''}
                    onChange={this.onTitleChange}
                    placeholder='Question'
                    style={{ maxWidth: '600px' }}
                  />
                </h3>
                <Input
                  autoHeight
                  name='description'
                  value={uiSchema && uiSchema['ui:description'] || ''}
                  onChange={this.onDescriptionChange}
                  placeholder='Description'
                  style={{ maxWidth: '600px' }}
                />
              </div>
              <div style={{ paddingLeft: '2em' }}>
                <Select
                  label='Question Type'
                  name='type'
                  type='select'
                  placeholder='Question Type...'
                  options={[
                    { text: 'Short answer', value: 'text', icon: 'text cursor' },
                    { text: 'Paragraph', value: 'textArea', icon: 'paragraph' },
                    { text: 'Multiple Choice', value: 'radio', icon: 'selected radio' },
                    { text: 'Checkboxes', value: 'checkboxes', icon: 'check square' },
                    { text: 'Dropdown', value: 'select', icon: 'chevron down' },
                    { text: 'List', value: 'textList', icon: 'list' },
                    { text: 'Table', value: 'table', icon: 'table' }
                  ]}
                  fluid
                  required
                  validationError='Question type is required'
                  width='200px'
                  onChange={this.props.onQuestionTypeChange}
                  value={this.props.getQuestionType()}
                  className={styles.noBorderBottom}
                />
              </div>
            </div>}
          <div style={{ padding: '2em' }}>
            <FieldComponent {...props} uiSchema={uiSchema} schema={schema} onChange={onChange} />
          </div>
          <DthcActions
            delete={() => deleteQuestion(objectKey)}
            id={objectKey}
            reset={(e) => { reset(e, this.props.closeHandler); }}
            save={() => this.props.commitUpdate(this.props.closeHandler)}
          />
        </Card.Content>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/Fields/SchemaFieldEditDesktop.js